import axios from "axios";

function getUrlKey(name) { //获取url 参数
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
};
// 本地打开时使用
// localStorage.setItem('openid', 'of3ha1dcL5wBNvUQAL23V2R8-tFQ');
var appid = 'wxb6a82cccf0d1c888',
    code = getUrlKey('code'),
    openid = null,
    // url = "https://xiaomi.event1.cn/";
    url = "https://xiaomi.event1.cn/test/index.html";
var wechat = function() {
        return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
    };
axios.post('https://chat-admin.event1.cn/api/Wechat/getConfig')
.then((res)=>{
    console.log(res);
    if(res.data.code==1){
        appid = res.data.data.app_id
        if (localStorage.getItem("openid")) {
            openid = localStorage.getItem("openid");
        }
        
        var local = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + url + "&response_type=code&scope=snsapi_userinfo#wechat_redirect";
        
        if(wechat()){
            if (openid == null) {
                if (code == null || code == '') {
                    location.href = local;
                } else {
                    localStorage.setItem('code', code);
                    let vdata = new FormData();
                    vdata.append("code", code);
                    axios.post("https://chat-admin.event1.cn/api/wechat/get_openid", vdata)
                        .then((res) => {
                            console.log(res)
                            if (res.data.code == 1) {
                                localStorage.setItem('openid', res.data.data.openid)
                                localStorage.setItem('avatar', res.data.data.headimgurl)
                                localStorage.setItem('nickname', res.data.data.nickname)
                            } else {
                                localStorage.clear();
                                alert('授权失败，请重新授权')
                            }
                        })
                        .catch((e) => {
                            console.log(e);
                        });
                }
            }
        }else{
            console.log('不在微信下');
        }
    }
}).catch((err)=>{
    console.log(err);
})





// WEBPACK FOOTER //
// ./src/openid.js